import { Card, Icon, Table } from 'semantic-ui-react';
import { kycState } from '../../../../model/details/kycState';
import React, { useState } from 'react';
import { signerState } from '../../../../model/details/signer';
import LeadKYCIdNowComponent from './LeadKYCIdNow.component';
import LeadKycWebIdComponent from './LeadKycWebId.component';
import { t } from 'i18next';
import { SignerType } from '../../../../types/Customer';
import { SignerDetailModalComponent } from '../../../misc/SignerDetailModal.component';
import { IdentificationProvider } from '../../../../model/details/identificationProvider';

type LeadKYCComponentProps = {
    data: typeof kycState;
    signers: typeof signerState;
    copy?: boolean;
};

function signerAuthorityLabel(signer: SignerType) {
    let label = null;
    switch (signer.authority?.toString()) {
        case 'PROFESSIONAL_AUTHORITY_ATTORNEY': {
            label = t('lead.detail.box.KYC.signer.authorized');
            break;
        }
        case 'PROFESSIONAL_AUTHORITY_OWNER': {
            label = t('lead.detail.box.KYC.signer.representative');
            break;
        }
    }

    return (
        <>
            {label && (
                <p className="ui blue horizontal label" style={{ marginLeft: '0.5rem' }}>
                    {label}
                </p>
            )}
        </>
    );
}

export default function LeadKYCComponent(props: LeadKYCComponentProps) {
    const [showModal, setShowModal] = useState(false);
    const [selectedSigner, setSelectedSigner] = useState<SignerType>();

    return (
        <Card fluid>
            {props.data.identificationProvider === IdentificationProvider.IDNOW ? (
                <LeadKYCIdNowComponent data={props.data} signers={props.signers} copy />
            ) : props.data.identificationProvider === IdentificationProvider.WEBID ? (
                <LeadKycWebIdComponent data={props.data} signers={props.signers} copy />
            ) : (
                <Card.Content>
                    <Card.Header>{t('lead.detail.box.KYC.missing.headline')}</Card.Header>
                    <Card.Description>{t('lead.detail.box.KYC.missing.description')}</Card.Description>
                </Card.Content>
            )}
            <Card.Content>
                <Card.Header>{t('lead.detail.box.KYC.signer.headline')}</Card.Header>
                <Card.Description>
                    <Table celled striped columns={3}>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>{t('lead.detail.box.KYC.signer.name')}</Table.HeaderCell>
                                {props.data.identificationProvider === IdentificationProvider.WEBID ? (
                                    <Table.HeaderCell>{t('lead.detail.box.KYC.signer.consent')}</Table.HeaderCell>
                                ) : null}
                                <Table.HeaderCell>{t('lead.detail.box.KYC.signer.state')}</Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {props.signers.length === 0 ? (
                                <Table.Row disabled textAlign={'center'}>
                                    <Table.Cell colSpan={3} disabled={true} textAlign={'center'} singleLine>
                                        {t('lead.detail.box.KYC.signer.emptyMessage')}
                                    </Table.Cell>
                                </Table.Row>
                            ) : (
                                props.signers.map((signer: SignerType, index: React.Key | null | undefined) => (
                                    <Table.Row key={index}>
                                        <Table.Cell width={1} singleLine>
                                            {signer.firstName + ' ' + signer.lastName}
                                            <Icon
                                                name="info circle"
                                                style={{ cursor: 'pointer', marginLeft: '0.5rem' }}
                                                onClick={() => {
                                                    setSelectedSigner(signer);
                                                    setShowModal(true);
                                                }}
                                            />
                                            {signerAuthorityLabel(signer)}
                                        </Table.Cell>
                                        {props.data.identificationProvider === IdentificationProvider.WEBID ? (
                                            <Table.Cell width={1} singleLine>
                                                {signer.termsAndConditionsConfirmed ? (
                                                    <Icon name="checkmark" />
                                                ) : (
                                                    <Icon name="minus" />
                                                )}
                                            </Table.Cell>
                                        ) : null}
                                        <Table.Cell width={1} singleLine>
                                            {signer.state || 'n/a'}
                                        </Table.Cell>
                                    </Table.Row>
                                ))
                            )}
                        </Table.Body>
                    </Table>
                </Card.Description>
            </Card.Content>
            <SignerDetailModalComponent
                showModal={showModal}
                onClose={() => setShowModal(false)}
                data={selectedSigner}
            />
        </Card>
    );
}
